export const LINK_PROTOCOL_VERSION = 1 as const;
export const LINK_LIFETIME_MS = 72 * 60 * 60 * 1_000;
export const LINK_CAPABILITY_BYTES = 32;
export const LINK_KEY_BYTES = 32;
export const LINK_IV_BYTES = 12;

export const LINK_ARTIFACT_CONTENT_TYPE = "application/vnd.quotation-link-artifact";
export const LINK_ENVELOPE_CONTENT_TYPE = "application/vnd.quotation-link-envelope";

export const LINK_ARTIFACT_MAGIC = "QLINK001";
export const LINK_ENVELOPE_MAGIC = "QLENV001";

export const DEFAULT_LINK_MAX_BYTES = 10 * 1024 * 1024;
export const DEFAULT_LINK_MAX_FILE_COUNT = 20;
export const DEFAULT_LINK_MAX_NAME_BYTES = 255;
export const DEFAULT_LINK_MAX_TYPE_BYTES = 255;
export const DEFAULT_LINK_MAX_MANIFEST_BYTES = 64 * 1024;

export const LINK_API_PATH = "/api/link";
export const LINK_ARTIFACT_API_PATH = "/api/link/artifact";

export const LINK_ACCESS_HEADER = "Authorization";
export const LINK_REVOKE_HEADER = "X-Link-Revoke-Token";
export const LINK_DIGEST_HEADER = "X-Link-Ciphertext-SHA256";
export const LINK_VERSION_HEADER = "X-Link-Protocol-Version";
export const LINK_EXPIRES_HEADER = "X-Link-Expires-At";
export const LINK_MAX_BYTES_HEADER = "X-Link-Max-Bytes";
export const LINK_SERVICE_HEADER = "X-Link-Service";
